export   const GET_Data_REQUEST = "GET_Data_REQUEST"
export const GET_Data_SUCCESS = "GET_Data_SUCCESS"
export const GET_Data_FAILURE = "GET_Data_FAILURE"